import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBooking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3125 15C10.0639 14.9999 9.82546 14.9011 9.64969 14.7253L7.77469 12.8503L9.10031 11.5247L10.3125 12.7369L13.3997 9.64969L14.7253 10.9753L10.9753 14.7253C10.7995 14.9011 10.5611 14.9999 10.3125 15Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.5625 13.125H1.875V4.6875H13.125V8.4375H15V2.8125C15 2.56386 14.9012 2.3254 14.7254 2.14959C14.5496 1.97377 14.3111 1.875 14.0625 1.875H12.1875V0H10.3125V1.875H8.4375V0H6.5625V1.875H4.6875V0H2.8125V1.875H0.9375C0.68886 1.875 0.450403 1.97377 0.274587 2.14959C0.0987721 2.3254 0 2.56386 0 2.8125L0 14.0625C0 14.3111 0.0987721 14.5496 0.274587 14.7254C0.450403 14.9012 0.68886 15 0.9375 15H6.5625V13.125Z",
		fill: "currentColor"
	})]
});
export default SvgIconBooking;
